import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Tag from "../../../Tag";

export const StyledTwoParticipantsContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.wsc.spacing[2]};
  width: 100%;
  overflow: hidden;
`;

export const StyledTwoParticipantsScore = styled(Box)`
  min-width: calc(${({ theme }) => theme.wsc.size.l} * 6);
  width: calc(${({ theme }) => theme.wsc.size.l} * 6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.wsc.spacing[0]};
`;

export const StyledFightingTag = styled(Tag)`
  background-color: ${({ theme }) => theme.wsc.palette.success[500]};
  color: ${({ theme }) => theme.wsc.palette.success[100]};

  &:hover {
    background-color: ${({ theme }) => theme.wsc.palette.success[500]};
  }
`;

export const StyledParticipantTitleWrapper = styled(Box)<{
  alignEnd?: boolean;
}>`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.wsc.spacing[2]};
  align-items: center;
  overflow: hidden;
  justify-content: ${({ alignEnd }) => (alignEnd ? "flex-end" : "flex-start")};
`;

export const StyledParticipantTitle = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
